const PopularEVs = [
  { label: '2025 Tesla Model 3', href: 'Tesla/2025/Model-3' },
  { label: '2024 Ford Mustang Mach-E', href: 'Ford/2024/Mustang-Mach-E' },
  { label: '2025 Hyundai Ioniq 6', href: 'Hyundai/2025/Ioniq-6' },
  { label: '2024 Kia EV9', href: 'Kia/2024/EV9' },
  { label: '2025 Nissan Ariya', href: 'Nissan/2025/Ariya' },
  { label: '2024 Chevrolet Equinox EV', href: 'Chevrolet/2024/Equinox-EV' },
  { label: '2025 Ford F-150 Lightning', href: 'Ford/2025/F-150-Lightning' },
  { label: '2025 Volkswagen ID.4', href: 'Volkswagen/2025/ID-4' },
  { label: '2025 BMW i4', href: 'BMW/2025/i4' },
  { label: '2025 Mercedes-Benz EQS', href: 'Mercedes-Benz/2025/EQS' },
  { label: '2025 Audi Q6 e-tron', href: 'Audi/2025/Q6-e-tron' },
  { label: '2025 Cadillac Lyriq', href: 'Cadillac/2025/Lyriq' },
  { label: '2025 Genesis GV60', href: 'Genesis/2025/GV60' },
  { label: '2025 Lucid Air', href: 'Lucid/2025/Air' },
  { label: '2025 Rivian R1T', href: 'Rivian/2025/R1T' },
];

const NewCars = [
  { label: '2025 Acura ADX', href: 'Acura/2025/ADX' },
  { label: '2025 Audi Q4 e-tron', href: 'Audi/2025/Q4-e-tron' },
  { label: '2025 Audi Q8 e-tron', href: 'Audi/2025/Q8-e-tron' },
  { label: '2025 BMW XM', href: 'BMW/2025/XM' },
  { label: '2025 Cadillac Escalade IQ', href: 'Cadillac/2025/Escalade-IQ' },
  { label: '2025 Chevrolet Silverado EV', href: 'Chevrolet/2025/Silverado-EV' },
  { label: '2025 FIAT 500e', href: 'FIAT/2025/500e' },
  { label: '2025 GMC Sierra EV', href: 'GMC/2025/Sierra-EV' },
  {
    label: '2025 Genesis Electrified GV70',
    href: 'Genesis/2025/Electrified-GV70',
  },
  { label: '2025 Hyundai IONIQ 5 N', href: 'Hyundai/2025/IONIQ-5-N' },
  { label: '2025 Lotus Eletre', href: 'Lotus/2025/Eletre' },
  { label: '2025 Lucid Air', href: 'Lucid/2025/Air' },
  { label: '2025 Mercedes-Benz EQE', href: 'Mercedes-Benz/2025/EQE' },
  { label: '2025 Nissan LEAF', href: 'Nissan/2025/LEAF' },
  { label: '2025 Subaru Solterra', href: 'Subaru/2025/Solterra' },
];

const NewSedans = [
  { label: '2024 Audi RS e-tron GT', href: 'Audi/2024/RS-e-tron-GT' },
  { label: '2024 Audi e-tron GT', href: 'Audi/2024/e-tron-GT' },
  { label: '2025 BMW i4', href: 'BMW/2025/i4' },
  { label: '2025 BMW i5', href: 'BMW/2025/i5' },
  { label: '2024 BMW i7', href: 'BMW/2024/i7' },
  { label: '2025 FIAT 500e', href: 'FIAT/2025/500e' },
  {
    label: '2024 Genesis Electrified G80',
    href: 'Genesis/2024/Electrified-G80',
  },
  { label: '2025 Hyundai IONIQ 5 N', href: 'Hyundai/2025/IONIQ-5-N' },
  { label: '2025 Lotus Eletre', href: 'Lotus/2025/Eletre' },
  { label: '2025 Lucid Air', href: 'Lucid/2025/Air' },
  { label: '2025 Mercedes-Benz EQE', href: 'Mercedes-Benz/2025/EQE' },
  { label: '2025 Nissan LEAF', href: 'Nissan/2025/LEAF' },
  { label: '2025 Subaru Solterra', href: 'Subaru/2025/Solterra' },
];

const NewSUVs = [
  { label: '2024 Acura ZDX', href: 'Acura/2024/ZDX' },
  { label: '2025 Audi Q4 e-tron', href: 'Audi/2025/Q4-e-tron' },
  { label: '2025 Audi Q8 e-tron', href: 'Audi/2025/Q8-e-tron' },
  { label: '2025 Audi SQ8 e-tron', href: 'Audi/2025/SQ8-e-tron' },
  { label: '2025 BMW XM', href: 'BMW/2025/XM' },
  { label: '2025 BMW iX', href: 'BMW/2025/iX' },
  { label: '2025 Cadillac Escalade IQ', href: 'Cadillac/2025/Escalade-IQ' },
  { label: '2025 Cadillac OPTIQ', href: 'Cadillac/2025/OPTIQ' },
  { label: '2024 Chevrolet Blazer EV', href: 'Chevrolet/2024/Blazer-EV' },
  { label: '2024 Ford Mustang Mach-E', href: 'Ford/2024/Mustang-Mach-E' },
  { label: '2025 GMC HUMMER EV SUV', href: 'GMC/2025/HUMMER-EV-SUV' },
  {
    label: '2025 Genesis Electrified GV70',
    href: 'Genesis/2025/Electrified-GV70',
  },
  { label: '2024 Honda Prologue', href: 'Honda/2024/Prologue' },
  { label: '2024 Kia EV9', href: 'Kia/2024/EV9' },
  { label: '2024 Kia Niro EV', href: 'Kia/2024/Niro EV' },
  { label: '2024 Lexus RZ', href: 'Lexus/2024/RZ' },
  { label: '2025 Lotus Eletre', href: 'Lotus/2025/Eletre' },
  { label: '2025 Polestar 3', href: 'Polestar/2025/3' },
  { label: '2025 Polestar 4', href: 'Polestar/2025/4' },
  { label: '2025 Rivian R1S', href: 'Rivian/2025/R1S' },
  { label: '2025 Subaru Solterra', href: 'Subaru/2025/Solterra' },
  { label: '2025 Tesla Model Y', href: 'Tesla/2025/Model-Y' },
  { label: '2024 Toyota bZ4X', href: 'Toyota/2024/bZ4X' },
  { label: '2025 VinFast VF 8', href: 'VinFast/2025/VF-8' },
  { label: '2024 VinFast VF 9', href: 'VinFast/2024/VF-9' },
  { label: '2024 Volkswagen ID.4', href: 'Volkswagen/2024/ID.4' },
  { label: '2025 Volvo EC40', href: 'Volvo/2025/EC40' },
  { label: '2025 Volvo EC30', href: 'Volvo/2025/EC30' },
];

const NewTrucks = [
  { label: '2025 Chevrolet Silverado EV', href: 'Chevrolet/2025/Silverado-EV' },
  { label: '2024 Ford F-150 Lightning', href: 'Ford/2024/F-150-Lightning' },
  { label: '2025 GMC Sierra EV', href: 'GMC/2025/Sierra-EV' },
  { label: '2025 Rivian R1T', href: 'Rivian/2025/R1T' },
  { label: '2025 Tesla Cybertruck', href: 'Tesla/2025/Cybertruck' },
];
const NewBestPerformance = [
  {
    label: '2025 Audi Q4 e-tron Sportback',
    href: 'Audi/2025/Q4-e-tron-Sportback',
  },
  {
    label: '2025 Audi Q8 e-tron Sportback',
    href: 'Audi/2025/Q8-e-tron-Sportback',
  },
  {
    label: '2025 Audi SQ8 e-tron Sportback',
    href: 'Audi/2025/SQ8-e-tron-Sportback',
  },
  { label: '2024 Ford Mustang Mach-E', href: 'Ford/2024/Mustang Mach-E' },
  { label: '2025 Mercedes-Benz EQS', href: 'Mercedes-Benz/2025/EQS' },
  { label: '2025 Hyundai IONIQ 5', href: 'Hyundai/2025/IONIQ-5' },
  { label: '2025 Porsche Taycan', href: 'Porsche/2025/Taycan' },
  { label: '2024 Rivian R1S', href: 'Rivian/2024/R1S' },
  { label: '2025 Tesla Model X', href: 'Tesla/2025/Model X' },
];

const NewBestBudget = [
  { label: '2025 Nissan Leaf', href: 'Nissan/2025/Leaf' },
  { label: '2024 Hyundai Kona Electric', href: 'Hyundai/2024/Kona-Electric' },
  { label: '2025 Nissan Leaf', href: 'Nissan/2025/Leaf' },
  { label: '2024 Chevrolet Equinox EV', href: 'Chevrolet/2024/Equinox-EV' },
  { label: '2024 Volkswagen ID.4', href: 'Volkswagen/2024/ID.4' },
];

export const AllInternalLinks = [
  { title: 'Popular EVs', list: PopularEVs },
  { title: 'New Cars', list: NewCars },
  { title: 'New Sedans', list: NewSedans },
  { title: 'New SUVs', list: NewSUVs },
  { title: 'New Trucks', list: NewTrucks },
  { title: 'Best Performance', list: NewBestPerformance },
  { title: 'Best Budget', list: NewBestBudget },
];
